module.exports = __webpack_public_path__ + "static/About-icon-3-Global-1cd29fdaee02fec86da86ca95586e776.png";